import './legacy/eccscript.js';